import { render } from "./ShareButton.vue?vue&type=template&id=eaf6c8b2&ts=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__